import { alarmCriticalities, alarmTypes } from 'src/entities'
import get from 'lodash/get'

export default {
  AlertType: {
    color: ({ criticality }) => get(alarmCriticalities, `${criticality}.color`, null),
    i18n: ({ key, criticality }) =>
      get(alarmTypes, `${key}.i18n`, null) || get(alarmCriticalities, `${criticality}.i18n`, null),
    icon: ({ key, criticality }) =>
      get(alarmTypes, `${key}.icon`, null) || get(alarmCriticalities, `${criticality}.icon`, null),
    value: ({ criticality }) => get(alarmCriticalities, `${criticality}.value`, null),
  },
  Group: {
    colors: ({ criticalities }) =>
      criticalities.map(criticality => get(alarmCriticalities, `${criticality}.color`, null)),
  },
  Channel: {
    colors: ({ criticalities }) =>
      criticalities.map(criticality => get(alarmCriticalities, `${criticality}.color`, null)),
  },
}
